// 首頁彈窗作用域：進入首頁時關閉不屬於首頁的彈窗（公告等 systemModal 與非白名單 modal）
//
// 彈窗狀態存在 Pinia、renderer 常駐 layouts/default.vue，本身無路由生命週期，
// 從 /guest 觸發的公告會一路跟著跳回首頁，因此在路由層界定作用域。
//
// 檔名字母序早於 url-modal.global.js：本檔清掉的 urlModalPending 會由後者在同一次
// 導航中依 /login、/register 重新標記，兩者不會互相覆蓋
import { useMainStore } from '@/stores/main'
import { INDEX_ALLOWED_MODALS, isIndexScope } from '@/utils/modalScope'
import { isIntentPath } from '@/utils/urlModal'

export default defineNuxtRouteMiddleware((to, from) => {
  // SSR 期間 store 為全新的 per-request 實例，彈窗狀態恆為 null，清理無意義
  if (import.meta.server) return

  const { $i18n } = useNuxtApp()
  const locales = $i18n?.locales?.value?.map((item) => item.code) || []

  // 僅在「從首頁作用域之外進入」時清理：/ ↔ /login 互跳與 ?lang= 切語系（i18n-query
  // 的 navigateTo）都屬同一作用域內導航，一併清理會打斷正在進行的強制驗證流程
  if (!isIndexScope(to.path, locales) || isIndexScope(from.path, locales)) return

  // 已登入時 /login、/register 會被 url-modal.global.js 的 abortNavigation() 或 pages/index/
  // 的 guest middleware 攔下，導航不會成真。middleware 的 store 副作用不隨導航中止回滾，
  // 先清窗會留下「頁面停在 /main 沒動、彈窗卻無聲消失」的殘留。/ 無 guest 守門不受影響
  const { isLoggedIn } = useAuthToken()
  if (isLoggedIn.value && isIntentPath(to.path, locales)) return

  useMainStore().closeModalsExcept(INDEX_ALLOWED_MODALS)
})
